import React from "react";

export default function TicketIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M6 7.357v1.35h1.5v-1.35H6ZM16.5 7.357v1.35H18v-1.35h-1.5ZM6 10.057v1.35h1.5v-1.35H6ZM16.5 10.057v1.35H18v-1.35h-1.5ZM6 12.757v1.35h1.5v-1.35H6ZM16.5 12.757v1.35H18v-1.35h-1.5ZM6 15.457v1.35h1.5v-1.35H6ZM16.5 15.457v1.35H18v-1.35h-1.5Z"
      />
      <path
        fill="currentColor"
        d="M2.25 4.582A2.25 2.25 0 0 0 0 6.832v2.25c0 .414.336.75.75.75a2.25 2.25 0 0 1 0 4.5.75.75 0 0 0-.75.75v2.25a2.25 2.25 0 0 0 2.25 2.25h19.5a2.25 2.25 0 0 0 2.25-2.25v-2.25a.75.75 0 0 0-.75-.75 2.25 2.25 0 1 1 0-4.5.75.75 0 0 0 .75-.75v-2.25a2.25 2.25 0 0 0-2.25-2.25H2.25Zm-.75 2.25a.75.75 0 0 1 .75-.75h19.5a.75.75 0 0 1 .75.75v1.575a3.751 3.751 0 0 0 0 7.35v1.575a.75.75 0 0 1-.75.75H2.25a.75.75 0 0 1-.75-.75v-1.575a3.751 3.751 0 0 0 0-7.35V6.832Z"
      />
    </svg>
  );
}
